import InnerNetworkComponent from './inner-network-component'

const NetworkComponent = ({ courseId, preAnalyticData, surveyId }) => {
  if (!preAnalyticData?.length) return null

  const filterPreAnalyticData = preAnalyticData.find(
    data => Number(data.courseId) === Number(courseId)
  )

  if (!filterPreAnalyticData?.surveyId) return null

  const sociogramId = filterPreAnalyticData.surveyId?.sociogram_id

  return (
    <div className='inner-network-component'>
      <InnerNetworkComponent
        sociogramId={sociogramId}
        filterPreAnalyticData={filterPreAnalyticData}
        courseId={courseId}
        surveyId={surveyId}
      />
    </div>
  )
}

export default NetworkComponent
